import { IconBase } from './iconBase';

import { CustomIconsProp } from '../types';

export const Ashby = ({ size, color, className }: CustomIconsProp) => (
  <IconBase className={className} viewBox={50} size={size}>
    <path
      d="M18.5752 39.7875V41H9V39.7875C11.4806 39.7875 12.4729 39.2076 13.3659 36.6771L22.693 9H27.1085L37.3783 36.6771C38.3705 39.2603 38.8667 39.7875 41 39.7875V41H25.9462V39.7875C29.5173 39.7875 29.8186 39.4457 28.7457 36.6771L26.0171 29.0857H17.7318L15.3008 36.5189C14.5908 39.0336 14.746 39.7875 18.5752 39.7875ZM21.6512 17.0659L18.2775 27.4514H25.4217L21.6512 17.0659Z"
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </IconBase>
);
